<h2 mat-dialog-title>{{ data?.title }}</h2>
<mat-dialog-content class="layout-row align-center-center">
  {{ data?.content }}
</mat-dialog-content>
<mat-dialog-actions class="layout-row align-center-center">
  <ng-container *ngIf="data?.title && data?.content; then button_validation; else button_ok"></ng-container>
  <ng-template #button_validation>
    <div class="button-div">
      <button class="tv-ns-secondary-large-button-on-light-bg left-margin-auto"[mat-dialog-close]="false">NON</button>
    </div>
    <div class="button-div">
      <button class="tv-ns-validation-large-button left-margin-auto"[mat-dialog-close]="true">OUI</button>
    </div>
  </ng-template>
  <ng-template #button_ok>
    <div class="button-div">
      <button class="tv-ns-validation-large-button left-margin-auto" [mat-dialog-close]="false">OK</button>
    </div>
  </ng-template>
</mat-dialog-actions>